/* ============================================================
   Revitune™ LymphFlow Pro — Custom Theme JS
   ============================================================ */

(function () {
  'use strict';

  /* ─── Countdown Timer (4h loop) ─── */
  function initCountdown() {
    const el = document.getElementById('rv-countdown');
    if (!el) return;

    const DURATION = 4 * 60 * 60 * 1000; // 4 hours in ms
    const KEY = 'rv_countdown_end';

    let endTime = parseInt(sessionStorage.getItem(KEY), 10);
    if (!endTime || endTime < Date.now()) {
      endTime = Date.now() + DURATION;
      sessionStorage.setItem(KEY, endTime);
    }

    function tick() {
      const remaining = endTime - Date.now();
      if (remaining <= 0) {
        endTime = Date.now() + DURATION;
        sessionStorage.setItem(KEY, endTime);
      }
      const h = Math.floor(remaining / 3600000).toString().padStart(2, '0');
      const m = Math.floor((remaining % 3600000) / 60000).toString().padStart(2, '0');
      const s = Math.floor((remaining % 60000) / 1000).toString().padStart(2, '0');
      el.textContent = h + ':' + m + ':' + s;
    }

    tick();
    setInterval(tick, 1000);
  }

  /* ─── Bundle Selector ─── */
  function initBundleSelector() {
    const cards = document.querySelectorAll('.rv-bundle-card');
    if (!cards.length) return;

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        cards.forEach(function (c) { c.classList.remove('selected'); });
        card.classList.add('selected');

        const price = card.dataset.price;
        const name = card.dataset.name;
        const variantId = card.dataset.variantId;

        // Update sticky bar price if present
        const stickyPrice = document.querySelector('.rv-sticky-price');
        if (stickyPrice && price) stickyPrice.textContent = price;

        // Update hidden variant input for Shopify ATC form
        const variantInput = document.getElementById('rv-variant-id');
        if (variantInput && variantId) variantInput.value = variantId;
      });
    });

    // Select first card by default
    if (cards[0]) cards[0].click();
  }

  /* ─── Before / After Slider ─── */
  function initBeforeAfter() {
    const containers = document.querySelectorAll('.rv-ba-container');
    containers.forEach(function (container) {
      const afterEl = container.querySelector('.rv-ba-after');
      const handle = container.querySelector('.rv-ba-handle');
      const range = container.querySelector('.rv-ba-range');
      if (!afterEl) return;

      function setPosition(pct) {
        afterEl.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
        if (handle) handle.style.left = pct + '%';
        if (range) range.value = pct;
      }

      // Range input control
      if (range) {
        range.addEventListener('input', function () {
          setPosition(parseFloat(range.value));
        });
        setPosition(50);
      }

      // Drag on container
      let dragging = false;

      function getPercent(clientX) {
        const rect = container.getBoundingClientRect();
        let pct = ((clientX - rect.left) / rect.width) * 100;
        return Math.min(100, Math.max(0, pct));
      }

      container.addEventListener('mousedown', function (e) {
        dragging = true;
        setPosition(getPercent(e.clientX));
      });
      window.addEventListener('mousemove', function (e) {
        if (dragging) setPosition(getPercent(e.clientX));
      });
      window.addEventListener('mouseup', function () { dragging = false; });

      container.addEventListener('touchstart', function (e) {
        dragging = true;
        setPosition(getPercent(e.touches[0].clientX));
      }, { passive: true });
      window.addEventListener('touchmove', function (e) {
        if (dragging) setPosition(getPercent(e.touches[0].clientX));
      }, { passive: true });
      window.addEventListener('touchend', function () { dragging = false; });
    });
  }

  /* ─── Accordion ─── */
  function initAccordions() {
    const items = document.querySelectorAll('.rv-accordion-item');
    items.forEach(function (item, idx) {
      const trigger = item.querySelector('.rv-accordion-trigger');
      const body = item.querySelector('.rv-accordion-body');
      if (!trigger || !body) return;

      // Open first item in FAQ, not in trust accordion
      const inFaq = item.closest('.rv-faq');
      if (inFaq && idx === 0) {
        item.classList.add('open');
        body.style.maxHeight = body.scrollHeight + 'px';
      }

      trigger.addEventListener('click', function () {
        const isOpen = item.classList.contains('open');

        // Close siblings in same accordion group
        const siblings = item.parentElement.querySelectorAll('.rv-accordion-item');
        siblings.forEach(function (s) {
          s.classList.remove('open');
          const sb = s.querySelector('.rv-accordion-body');
          if (sb) sb.style.maxHeight = null;
        });

        if (!isOpen) {
          item.classList.add('open');
          body.style.maxHeight = body.scrollHeight + 'px';
        }
      });
    });
  }

  /* ─── Hero Thumbnails ─── */
  function initHeroThumbs() {
    const thumbs = document.querySelectorAll('.rv-hero-thumb');
    const mainImg = document.querySelector('.rv-hero-main-image img');
    if (!thumbs.length || !mainImg) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        const src = thumb.dataset.src;
        if (src) mainImg.src = src;
      });
    });

    if (thumbs[0]) thumbs[0].classList.add('active');
  }

  /* ─── Sticky Cart Bar ─── */
  function initStickyBar() {
    const bar = document.getElementById('rv-sticky-bar');
    const hero = document.getElementById('rv-product-hero');
    if (!bar) return;

    function update() {
      const threshold = hero ? hero.offsetHeight : 400;
      if (window.scrollY > threshold) {
        bar.classList.add('visible');
      } else {
        bar.classList.remove('visible');
      }
    }

    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ─── Stats Circles (Animate on scroll) ─── */
  function initStats() {
    const circles = document.querySelectorAll('.rv-circle-fill');
    if (!circles.length) return;

    const circumference = 2 * Math.PI * 52; // r=52

    circles.forEach(function (circle) {
      const pct = parseFloat(circle.dataset.percent || 0);
      circle.style.strokeDasharray = circumference;
      circle.style.strokeDashoffset = circumference; // start at 0

      // Animate when visible
      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            const offset = circumference - (pct / 100) * circumference;
            circle.style.strokeDashoffset = offset;
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.4 });

      observer.observe(circle);
    });
  }

  /* ─── Add to Cart (Sticky bar ATC) ─── */
  function initStickyATC() {
    const btn = document.getElementById('rv-sticky-atc-btn');
    if (!btn) return;

    btn.addEventListener('click', function () {
      const mainAtc = document.querySelector('.rv-atc-form button[type="submit"], #rv-atc-btn');
      if (mainAtc) {
        mainAtc.click();
      }
    });
  }

  /* ─── Init all ─── */
  function init() {
    initCountdown();
    initBundleSelector();
    initBeforeAfter();
    initAccordions();
    initHeroThumbs();
    initStickyBar();
    initStats();
    initStickyATC();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
